export class CCliente{
  nombres:string='';
  apellido_paterno:string='';
  apellido_materno:string='';
  sexo:string='';
  correo_electronico:string='';
  numero_telefono:string=''
}
